import { text_colorTextSecondary } from 'ext-ui/style/colors'
import BarChartIcon from 'ext-ui/svg/icon/BarChartIcon'
import LineChartIcon from 'ext-ui/svg/icon/LineChartIcon'
import PieChartIcon from 'ext-ui/svg/icon/PieChartIcon'
import TrendLineIcon from 'ext-ui/svg/icon/TrendLineIcon'
import React from 'react'
import ReceiptAgentAvatar from 'src/components/ReceiptAgentAvatar/ReceiptAgentAvatar'
import { useTranslate } from 'src/localization/Trns'

import styles from './ReportingAgentChatEmptyState.style'

interface ReportingAgentChatEmptyStateProps {
  onPromptClick: (prompt: string) => void
}

const ReportingAgentChatEmptyState: React.FC<
  ReportingAgentChatEmptyStateProps
> = ({ onPromptClick }) => {
  const translate = useTranslate()
  const prompts = [
    {
      title: translate(
        'Show a spending breakdown by expense category label for last quarter',
      ),
      icon: (
        <PieChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt:
        'Show a spending breakdown by expense category label for last quarter',
    },
    {
      title: translate(
        'Show my spending trend on transportation over the last 30 days',
      ),
      icon: (
        <TrendLineIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt: 'Show my spending trend on transportation over the last 30 days',
    },
    {
      title: translate(
        'Show month over month spending on meals from the last completed month',
      ),
      icon: (
        <BarChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt:
        'Show month over month spending on meals from the last completed month',
    },
    {
      title: translate('Show top merchant categories by spend this month'),
      icon: (
        <LineChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt: 'Show top merchant categories by spend this month',
    },
  ]

  return (
    <div css={styles} className="ReportingAgentChatEmptyState">
      <div className="agent-avatar" aria-hidden="true">
        <ReceiptAgentAvatar
          className="reporting-agent-avatar"
          testId="reporting-agent-avatar"
        />
      </div>
      <h2 className="empty-state-title">
        {translate('Get started with the Reporting Agent')}
      </h2>
      <p className="empty-state-subtitle">
        {translate(
          "Ask me anything about your expenses and I'll create custom reports for you",
        )}
      </p>
      <div className="prompts-list">
        {prompts.map((prompt) => (
          <button
            className="prompt-button"
            key={prompt.prompt}
            type="button"
            onClick={(): void => onPromptClick(prompt.prompt)}
          >
            <span className="prompt-button-icon" aria-hidden="true">
              {prompt.icon}
            </span>
            {prompt.title}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ReportingAgentChatEmptyState
